import React from 'react'
import PropTypes from 'prop-types'
import _ from 'underscore'
import { touch } from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import { switchTechnicalCardTab, storeCarDataFormValues, clearCarDataStore } from './actions'
import CarDataForm from './carDataForm.component'
import { configuration } from '../../../configuration'

import './styles.css'


class CarData extends React.Component {

  static propTypes = {
    carDataStore: PropTypes.shape({
      activeKey: PropTypes.string,
    }),
    switchTechnicalCardTab: PropTypes.func.isRequired,
    switchCheckoutContent: PropTypes.func.isRequired,
    validCarDataData: PropTypes.func.isRequired,
    storeCarDataFormValues: PropTypes.func.isRequired,
    checkoutStore: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

  handleSelect(selected) {
    this.props.switchTechnicalCardTab(selected);
  }

  componentWillReceiveProps(props) {
    if (props.carDataStore.canRedirect && props.carDataStore.carDataData) {
      props.switchCheckoutContent('services');
    }
  }

  handleNext() {
    const isValid = this.props.validCarDataData('formOnly') ;
    if (isValid) {
      this.props.storeCarDataFormValues({
        ...this.props.carDataForm.values,
      });
    }

    if (this.props.carDataForm.syncErrors) {
      _.each(Object.keys(this.props.carDataForm.syncErrors), (field) => {
        this.props.touchFormField('carDataForm', field);
      });
    }
  }

  componentWillUnmount() {
    this.props.clearCarDataStore(['canRedirect']);
  }

  render() {
    return (
      <div>
        <div className="child-div-centered">
          <CarDataForm />
        </div>
        <Row>
          <Col sm={12} md={3} mdOffset={9} className="offset-md-9">
            <button className=" responsivebutton jump pull-right blue-button-active"
                    style={{backgroundColor: configuration().clientColor,
                        borderColor: configuration().clientColor,
                    }}
                    onClick={this.handleNext}>
                <span className="labelFlip1">SIGUIENTE</span> <span className="labelFlip2" style={{visibility: 'hidden'}}>SIGUIENTE</span> {configuration().arrowInButon ? <i className="fa fa-angle-right" aria-hidden="true"></i> : ''}
            </button>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
    carDataStore: state.checkout.carData,
    carDataForm: state.form.carDataForm || {},
    carPlateForm: state.form.carPlateForm || {},
    checkoutStore: state.checkout.checkoutRoot,
})

const bindActions = dispatch => ({
  switchTechnicalCardTab: selected => dispatch(switchTechnicalCardTab(selected)),
  storeCarDataFormValues: values => dispatch(storeCarDataFormValues(values)),
  clearCarDataStore: props => dispatch(clearCarDataStore(props)),
  touchFormField: (form, field) => dispatch(touch(form, field)),
})

export default connect(mapStateToProps, bindActions)(CarData)



// WEBPACK FOOTER //
// ./src/workflow/checkout/carData/index.js